import { t } from "i18next";
import React, { useEffect } from "react";
import SSONavigationContent from "pages/sso/SSONavigationContent";
import { Brands, useAuth, useBranding } from "providers";
import { useNavigate } from "react-router";
import { LINK } from "utils/constants/Constants";

export const PayMonthlyInvoice = () => {
  const { user } = useAuth();
  const { brandConfig } = useBranding();
  const navigate = useNavigate();

  const isQaEnvironment =
    window.location.hostname.includes("dev") ||
    window.location.hostname.includes("qa") ||
    window.location.hostname.includes("uat") ||
    window.location.hostname.includes("reg") ||
    LINK.QA_ORIGINS.includes(window.location.origin.toLowerCase());

  useEffect(() => {

    document.title = t('pageTitleADA.payMonthlyInvoice');

    if (!user?.paymentFeatureEnabled) {
      navigate("/");
    }
  }, [user, navigate]);

  if (isQaEnvironment) {
    return (
      <SSONavigationContent
        header={t("sso.header.payMonthlyInvoice")}
        ssoUrl={brandConfig.brandName === Brands.AVMED ? LINK.WELLS_FARGO_AVMED_SSO_QA : LINK.WELLS_FARGO_SHP_SSO_QA}
        dataTestId="ssoLinkPayMonthlyInvoice"
        targetName={"PayMonthlyInvoice"}
      />
    );
  } else {
    return (
      <SSONavigationContent
        header={t("sso.header.payMonthlyInvoice")}
        ssoUrl={brandConfig.brandName === Brands.AVMED ? LINK.WELLS_FARGO_AVMED_SSO_PROD : LINK.WELLS_FARGO_SHP_SSO_PROD}
        dataTestId="ssoLinkPayMonthlyInvoice"
        targetName={"PayMonthlyInvoice"}
      />
    );
  }
};

export default PayMonthlyInvoice;
